'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('../Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ContentCardEmbeddedVideo = require('./ContentCardEmbeddedVideo.css');

var _ContentCardEmbeddedVideo2 = _interopRequireDefault(_ContentCardEmbeddedVideo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentCardEmbeddedVideo = function (_React$Component) {
  _inherits(ContentCardEmbeddedVideo, _React$Component);

  function ContentCardEmbeddedVideo(props) {
    _classCallCheck(this, ContentCardEmbeddedVideo);

    var _this = _possibleConstructorReturn(this, (ContentCardEmbeddedVideo.__proto__ || Object.getPrototypeOf(ContentCardEmbeddedVideo)).call(this, props));

    _this.state = { modalOpen: false };
    _this.handleCloseClick = _this.handleCloseClick.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(ContentCardEmbeddedVideo, [{
    key: 'handleCloseClick',
    value: function handleCloseClick() {
      this.setState({ modalOpen: false });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.modalEnabled) {
        this.setState({ modalOpen: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash
        },
        _react2.default.createElement(
          _Modal2.default,
          { modalOpen: this.state.modalOpen, handleCloseClick: this.handleCloseClick },
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash + ' ' + 'videoContainer'
            },
            _react2.default.createElement('div', {
              className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash + ' ' + 'topGradient'
            }),
            _react2.default.createElement('iframe', {
              allowFullScreen: true,
              frameBorder: '0',
              src: this.props.src,
              title: this.props.title,
              className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash
            }),
            _react2.default.createElement(
              'div',
              {
                className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash + ' ' + ('cover ' + (this.state.modalOpen ? 'hidden' : ''))
              },
              _react2.default.createElement('button', { onClick: function onClick() {
                  _this2.handleClick();
                },
                className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash
              })
            ),
            _react2.default.createElement('div', {
              className: 'jsx-' + _ContentCardEmbeddedVideo2.default.__scopedHash + ' ' + 'bottomGradient'
            })
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _ContentCardEmbeddedVideo2.default.__scopedHash,
          css: _ContentCardEmbeddedVideo2.default.__scoped
        })
      );
    }
  }]);

  return ContentCardEmbeddedVideo;
}(_react2.default.Component);

ContentCardEmbeddedVideo.propTypes = {
  title: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  modalEnabled: _propTypes2.default.bool
};

ContentCardEmbeddedVideo.defaultProps = {
  messengerShareButton: null,
  modalEnabled: false
};

exports.default = ContentCardEmbeddedVideo;